var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapPumpConnOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_Screens",
    "data-name": "Main Screens"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.73,95.26c-1.43,0-2.59-1.17-2.59-2.6V10.63C13.14,4.77,17.89,0,23.73,0h243.68c1.43,0,2.59,1.17,2.59,2.6s-1.16,2.6-2.59,2.6H23.73c-2.98,0-5.4,2.43-5.4,5.42v82.03c0,1.44-1.16,2.6-2.59,2.6Z",
    fill: "#6a7084",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 101.48,
    width: 40.13,
    height: 5.21,
    fill: "#6a7084",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.26,
    y: 93.01,
    width: 8.69,
    height: 7.5,
    fill: "#6a7084",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63,93.34v6.85h-8.04v-6.85h8.04M20.27,92.69h-9.33v8.15h9.33v-8.15h0Z",
    fill: "#404041",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.06,
    y: 101.34,
    width: 5.58,
    height: 5.6,
    fill: "#6a7084",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31,101.67v4.95h-4.93v-4.95h4.93M32.96,101.02h-6.23v6.25h6.23v-6.25h0Z",
    fill: "#404041",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.04,
    y: 100.39,
    width: 23.14,
    height: 8.52,
    fill: "#6a7084",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.85,100.72v7.87H4.36v-7.87h22.49M27.5,100.07H3.71v8.52s0,.65,0,.65h23.79v-9.17h0Z",
    fill: "#404041",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.39,138.67c-2.75,0-4.99-2.25-4.99-5.01v-19.94H.32v-5.47h30.57v5.47h-1.08v19.94c0,2.76-2.24,5.01-4.99,5.01H6.39Z",
    fill: "#6a7084",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,108.58v4.81h-1.08v20.27c0,2.59-2.09,4.68-4.67,4.68H6.39c-2.58,0-4.67-2.1-4.67-4.68v-20.27H.65v-4.81h29.92M31.22,107.93H0v6.12h1.08v19.62c0,2.94,2.38,5.33,5.31,5.33h18.43c2.93,0,5.31-2.39,5.31-5.33v-19.62h1.08v-6.12h0Z",
    fill: "#404041",
    strokeWidth: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapPumpConnOff);
export default __webpack_public_path__ + "static/media/air_gap_pump_conn_off.631ccb0246e58be74110cb27269d4a91.svg";
export { ForwardRef as ReactComponent };